import { getProducts, getSKUs, getSKU } from '../../../app/api';

let productsList = null;
let productsPromise = null;

const skusByProductId = new Map();
const skusPromisesByProductId = new Map();

const skuById = new Map();
const skuPromisesById = new Map();

export function invalidateProductSkuPickerCache() {
  productsList = null;
  productsPromise = null;
  skusByProductId.clear();
  skusPromisesByProductId.clear();
  skuById.clear();
  skuPromisesById.clear();
}

export async function fetchProductsCached() {
  if (productsList) return productsList;
  if (!productsPromise) {
    productsPromise = getProducts()
      .then((res) => {
        const list = res.data?.products || [];
        productsList = list;
        return list;
      })
      .catch((err) => {
        productsPromise = null;
        throw err;
      });
  }
  return productsPromise;
}

export async function fetchSkusForProductCached(productId) {
  if (!productId) return [];
  if (skusByProductId.has(productId)) return skusByProductId.get(productId);
  if (!skusPromisesByProductId.has(productId)) {
    const promise = getSKUs(productId)
      .then((res) => {
        const list = res.data || [];
        skusByProductId.set(productId, list);
        skusPromisesByProductId.delete(productId);
        return list;
      })
      .catch((err) => {
        skusPromisesByProductId.delete(productId);
        throw err;
      });
    skusPromisesByProductId.set(productId, promise);
  }
  return skusPromisesByProductId.get(productId);
}

export async function fetchSkuCached(skuId) {
  if (!skuId) return null;
  if (skuById.has(skuId)) return skuById.get(skuId);
  if (!skuPromisesById.has(skuId)) {
    const promise = getSKU(skuId)
      .then((res) => {
        const sku = res.data || null;
        if (sku) skuById.set(skuId, sku);
        skuPromisesById.delete(skuId);
        return sku;
      })
      .catch((err) => {
        skuPromisesById.delete(skuId);
        throw err;
      });
    skuPromisesById.set(skuId, promise);
  }
  return skuPromisesById.get(skuId);
}

export function primeSkusForProduct(productId, skus) {
  if (!productId || !Array.isArray(skus)) return;
  skusByProductId.set(productId, skus);
}

export function primeSku(sku) {
  if (!sku?.id) return;
  skuById.set(sku.id, sku);
}
